import React, { useRef } from 'react';
import AsideMenuList from '../AsideMenuList';
import { TabPane } from '../common/styled-components';

interface Props {
  onEditGroup: (id: string) => void;
}

const AsideMenu = ({ onEditGroup }: Props) => {
  const tabPaneRef = useRef(null);
  return (
    <TabPane ref={tabPaneRef}>
      <div className="aside-menu">
        <AsideMenuList tabPaneRef={tabPaneRef} onEditGroup={onEditGroup} />
      </div>
    </TabPane>
  );
};

export default AsideMenu;
